import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/material_templates',
  component: Management,
  redirect: '/material_templates/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/material_templates/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listMaterialTemplates
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/material_templates/ListTable'),
          meta: {
            auth: Auth.listMaterialTemplates,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/material_templates/New'),
      meta: {
        auth: Auth.createMaterialTemplate
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/material_templates/Edit'),
      meta: {
        auth: Auth.updateMaterialTemplate
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/material_templates/DetailLayout'),
      meta: {
        auth: Auth.showMaterialTemplate
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/material_templates/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showMaterialTemplate
          }
        },
        // 资料参考记录
        {
          path: 'materials',
          component: () => import('@/views/material_templates/details/Materials'),
          meta: {
            tabName: 'materials', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listMaterials
          }
        }
      ]
    }
  ]
}
